export const GET_CURRENT_VERSION_REQUEST = "GET_CURRENT_VERSION_REQUEST"
export const GET_CURRENT_VERSION_SUCCESS = "GET_CURRENT_VERSION_SUCCESS"
export const GET_CURRENT_VERSION_FAILURE = "GET_CURRENT_VERSION_FAILURE"

export const UPLOAD_FILE_REQUEST = "UPLOAD_FILE_REQUEST"
export const UPLOAD_FILE_SUCCESS = "UPLOAD_FILE_SUCCESS"
export const UPLOAD_FILE_FAILURE = "UPLOAD_FILE_FAILURE"
